import { create, get } from '@github/webauthn-json';

// Note: The Laravel Laragear package returns options in a format that compatible with webauthn-json
// v2+ creates and gets accept JSON-compatible objects directly (strings for buffers).

export const webAuthnService = {
    /**
     * Check if the device supports biometric/platform authenticators (Fingerprint, FaceID, Windows Hello)
     */
    isSupported: async (): Promise<boolean> => {
        if (!window.PublicKeyCredential) {
            return false;
        }
        // Check for platform authenticator availability (internal sensor)
        try {
            const available = await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
            return available;
        } catch (e) {
            return false;
        }
    },

    /**
     * Register a new credential on this device
     * @param options The JSON options returned from the server
     */
    register: async (options: any) => {
        // Laragear likely returns the PublicKeyCredentialCreationOptions directly (without the 'publicKey' wrapper key)
        // ensure we have the correct structure for @github/webauthn-json
        const creationOptions = options.publicKey ? options : { publicKey: options };

        const credential = await create(creationOptions);
        return credential;
    },

    /**
     * Login using a credential
     * @param options The JSON options returned from the server
     */
    login: async (options: any) => {
        // Laragear likely returns the PublicKeyCredentialRequestOptions directly
        // ensure we have the correct structure for @github/webauthn-json
        const requestOptions = options.publicKey ? options : { publicKey: options };

        const credential = await get(requestOptions);
        return credential;
    }
};


